module.exports = __webpack_public_path__ + "img/aptitude12.e242801b.jpg";